import { AmbientLight, MathUtils, Scene, Vector3 } from "three";
import { CameraController } from "../../componets3D/CameraController";
import { MouseEvents } from "../../componets3D/MouseEvents";
import ObserverEmitter, { EVENTS } from "../../../emitter/Observer";
import { audiosAssets } from "../../../assets/audio";
import { CharcterOxxo } from "../objects/CharacterOxxo";
import { MapOxxoIntroduction, MonitorIntro } from "../objects/Topics";
import { Cube } from "../objects/Cube";


export class SceneIntroducion extends Scene {
	constructor(loadingManager, container, render, character = new CharcterOxxo(), enviro, selectedCharacterIntroduction) {
		super();
		this.characterSelected = character;
		this.environment = enviro;
		this.camera = new CameraController();
		this.loadingManager = loadingManager;
		this.mouseEvents = new MouseEvents(container, render, this.camera, this);
		this.light()
		this.create();
		this.listeners()
		this.renderAnimations();
		this.selectCharacter = null
		this.selectedCharacterIntroduction = selectedCharacterIntroduction
		this.idCharacterSelected = 0;
	}

	create() {
		this.mapmenu = new MapOxxoIntroduction(this.loadingManager);
		this.add(this.mapmenu);

		this.createCharacter()
		this.createCubeSelect()

		this.monitorIntro = new MonitorIntro(this.loadingManager)

	}

	light() {
		this.ambient = new AmbientLight();
		this.ambient.color.set(0xffffff);
		this.ambient.intensity = 1;
		this.add(this.ambient);
	}

	SceneInitialState() {
		this.mouseEvents.disposeInteractions();
	}

	createCharacter() {
		this.characterAndatti = new CharcterOxxo(this.loadingManager, 1, { x: -12.7326, y: -0.97, z: 2.6906 }, { x: 0, y: 0.3382, z: 0 }, 0.1);
		this.add(this.characterAndatti);
		this.characterCel = new CharcterOxxo(this.loadingManager, 2, { x: -13.2953, y: -0.97, z: 3.0808 }, { x: 0, y: 0.669, z: 0 }, 0.1);
		this.add(this.characterCel);
		this.characterPremia = new CharcterOxxo(this.loadingManager, 3, { x: -12.0516, y: -0.97, z: 2.6906 }, { x: 0, y: -0.3235, z: 0 }, 0.1);
		this.add(this.characterPremia);
		this.characterSpin = new CharcterOxxo(this.loadingManager, 4, { x: -11.5833, y: -0.97, z: 3.1135 }, { x: 0, y: -0.7646, z: 0 }, 0.1);
		this.add(this.characterSpin);
	}

	createCubeSelect() {
		this.cube = new Cube(0.8, { x: -12.7113, y: -0.7154, z: 2.6906 }, 0.44, 0x00ff00);
		this.cube.visible = false;
		this.cube2 = new Cube(0.81, { x: -13.3108, y: -0.7154, z: 3.0461 }, 0.44, 0x000011);
		this.cube2.visible = false;
		this.cube3 = new Cube(0.82, { x: -12.0897, y: -0.7154, z: 2.6906 }, 0.44, 0x00f3);
		this.cube3.visible = false;
		this.cube4 = new Cube(0.83, { x: -11.5833, y: -0.7346, z: 3.1135 }, 0.44, 0x29f1ff);
		this.cube4.visible = false;
		this.add(this.cube, this.cube2, this.cube3, this.cube4);
		this.mouseEvents.objectsToValue = [this.cube, this.cube2, this.cube3, this.cube4];

	}

	hiddenMarcadores() {
		this.characterAndatti.MarcadorAndatti.visible = false;
		this.characterCel.MarcadorCel.visible = false;
		this.characterPremia.MarcadoPremia.visible = false;
		this.characterSpin.MarcadorSpin.visible = false;
	}

	initSceneVar() {
		this.characterAndatti.visible = true;
		this.characterCel.visible = true;
		this.characterPremia.visible = true;
		this.characterSpin.visible = true;

		this.idCharacterSelected = 0;

		this.characterPremia.MarcadoPremia.scale.x = 1.8
		this.characterPremia.MarcadoPremia.scale.z = 1.8

		this.hiddenMarcadores()

		this.monitorIntro.visible = false
		this.monitorIntro.initMonitor()
		this.add(this.monitorIntro)
	}

	initScene() {
		this.initSceneVar()


		this.characterAndatti.position.set(-12.7326, -0.97, 2.6906)
		this.characterAndatti.rotation.set(0, 0.3382, 0)

		this.characterCel.position.set(-13.2953, -0.97, 3.0808)
		this.characterCel.rotation.set(0, 0.669, 0)

		this.characterPremia.position.set(-12.0516, -0.97, 2.6906)
		this.characterPremia.rotation.set(0, -0.3235, 0)

		this.characterSpin.position.set(-11.5833, -0.97, 3.1135)
		this.characterSpin.rotation.set(0, -0.7646, 0)
	}

	listeners() {
		ObserverEmitter.on(EVENTS.move_escritorio_introduction, () => {
			this.camera.control.maxAzimuthAngle = Infinity;
			this.camera.control.minAzimuthAngle = Infinity;
			this.camera.moveCameraToPoint(new Vector3(-7.5596, -2.7062, 5.5432), 1, new Vector3(-6.786, -2.86, 4.877), () => {
				this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
				this.camera.control.minPolarAngle = MathUtils.degToRad(20);
				this.camera.control.maxAzimuthAngle = -0.86;
				this.camera.control.minAzimuthAngle = -2;
				this.camera.control.minDistance = 1;
				this.camera.control.maxDistance = 3;
				this.camera.control.enablePan = false;
				this.camera.control.enableRotate = false;
				this.camera.control.enableZoom = false;

				this.hiddenMarcadores()

				this.selectCharacter.visible = true
				this.selectCharacter.position.set(-6.5874, -3, 4.5597);
				this.selectCharacter.rotation.set(0, -0.8749, 0);

				this.monitorIntro.visible = true

			});
		});

		ObserverEmitter.on(EVENTS.tema6.intro.monitorActivi, (step = "") => {
			switch (step) {
				case "move_monitor":
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.moveCameraToPoint(new Vector3(-12.2665, 0.0093, 2.7979), 1, new Vector3(-10.716, 0, 2.752), () => {
						this.camera.control.minDistance = 1.4;
						this.camera.control.maxDistance = 2;

						ObserverEmitter.emit(EVENTS.tema6.intro.listenMonitor, "move_monitor")
					});
					break;
				case "monitor_two_texture":
					this.monitorIntro.selectTexture("two")
					break;
				default:
					break;
			}
		})
	}

	ActivitiSelected(activity) {
		switch (activity) {
			case 0:
				this.initScene()
				this.camera.moveCameraToPoint(new Vector3(-12.4058, -0.5368, 4.338), 2, new Vector3(-11.992, -1.74, -9.102), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = false;
					this.camera.control.maxAzimuthAngle = Infinity;
					this.camera.control.minAzimuthAngle = Infinity;
					this.camera.control.minDistance = 13.5;
					this.camera.control.maxDistance = 13.5;
					this.camera.control.enablePan = false;
					this.mouseListeners()
				})
				break;
			default:
				this.camera.moveCameraToPoint(new Vector3(-8.8658, -0.1739, 1.7731), 1, new Vector3(-7.758, -0.494, 0.201), () => {
					this.camera.control.maxPolarAngle = MathUtils.degToRad(100);
					this.camera.control.minPolarAngle = MathUtils.degToRad(20);
					this.camera.control.enableRotate = true;
					this.camera.control.maxAzimuthAngle = -0.86;
					this.camera.control.minAzimuthAngle = -2;
					this.camera.control.minDistance = 1;
					this.camera.control.maxDistance = 3;
					this.camera.control.enablePan = false;
				});
				break;
		}
	}

	onClearAnimationsIdle() {
		this.characterAndatti.onAnimateIdle();
		this.characterCel.onAnimateIdle();
		this.characterSpin.onAnimateIdle();
		this.characterPremia.onAnimateIdle();
	}

	mouseListeners() {
		this.mouseEvents.onPointerUp((interactions) => {
			if (interactions[0]) {
				this.onClearAnimationsIdle();
				ObserverEmitter.emit(EVENTS.audiosEvents.createAudioActionButton, audiosAssets.gestos.gestoPersonaje)
				switch (interactions[0].object.name) {
					case "cube-0.8":
						// console.log("andati");
						this.selectCharacter = this.characterAndatti
						this.idCharacterSelected = 1;
						this.selectedCharacterIntroduction.after = 1
						ObserverEmitter.emit(EVENTS.selectCharacterIntroduction, 1);
						localStorage.setItem("character", 1);
						this.characterAndatti.onAnimationFestejo();

						this.characterAndatti.MarcadorAndatti.visible = true;
						this.characterCel.MarcadorCel.visible = false;
						this.characterPremia.MarcadoPremia.visible = false;
						this.characterSpin.MarcadorSpin.visible = false;
						break;
					case "cube-0.81":
						// console.log("cel");
						this.selectCharacter = this.characterCel
						this.idCharacterSelected = 2;
						this.selectedCharacterIntroduction.after = 2
						ObserverEmitter.emit(EVENTS.selectCharacterIntroduction, 2);
						localStorage.setItem("character", 2);
						this.characterCel.onAnimationFestejo();

						this.characterAndatti.MarcadorAndatti.visible = false;
						this.characterCel.MarcadorCel.visible = true;
						this.characterPremia.MarcadoPremia.visible = false;
						this.characterSpin.MarcadorSpin.visible = false;
						break;
					case "cube-0.82":
						// console.log("premia");
						this.selectCharacter = this.characterPremia
						this.idCharacterSelected = 3;
						this.selectedCharacterIntroduction.after = 3
						ObserverEmitter.emit(EVENTS.selectCharacterIntroduction, 3);
						localStorage.setItem("character", 3);
						this.characterPremia.onAnimationFestejo();

						this.characterAndatti.MarcadorAndatti.visible = false
						this.characterCel.MarcadorCel.visible = false;
						this.characterPremia.MarcadoPremia.visible = true;
						this.characterSpin.MarcadorSpin.visible = false;

						break;
					case "cube-0.83":
						// console.log("spin");
						this.selectCharacter = this.characterSpin
						this.idCharacterSelected = 4;
						this.selectedCharacterIntroduction.after = 4
						ObserverEmitter.emit(EVENTS.selectCharacterIntroduction, 4);
						localStorage.setItem("character", 4);
						this.characterSpin.onAnimationFestejo();

						this.characterAndatti.MarcadorAndatti.visible = false
						this.characterCel.MarcadorCel.visible = false;
						this.characterPremia.MarcadoPremia.visible = false;
						this.characterSpin.MarcadorSpin.visible = true;

						break;
					default:
						break;
				}
			}
		});
	}

	renderAnimations(delta) {
		this.characterAndatti.renderAnimations(delta);
		this.characterCel.renderAnimations(delta);
		this.characterPremia.renderAnimations(delta);
		this.characterSpin.renderAnimations(delta);
	}
}
